import { apiRequest } from '@/common/utils/request.common'
import {
  API_BASE_URL_ACCOUNT,
  HTTP_METHOD_PUT,
} from '@/common/utils/request.const'
export const putConnectionSns = async ({ token, data }) => {
  try {
    const response = await apiRequest({
      url: `${API_BASE_URL_ACCOUNT}/v1/connections`,
      method: HTTP_METHOD_PUT,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`,
      },
      data,
    })

    return response
  } catch (error) {
    return { error: error.response }
  }
}
